// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 24qDGfvb2rMn6oy8PVF95d
// Component: CMg-M2mVji

import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/react-web/lib/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";

import "@plasmicapp/react-web/lib/plasmic.css";

import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import plasmic_plasmic_rich_components_css from "../plasmic_rich_components/plasmic_plasmic_rich_components.module.css"; // plasmic-import: jkU633o1Cz7HrJdwdxhVHk/projectcss
import plasmic_pro_pro_css from "../pro_pro/plasmic_pro_pro.module.css"; // plasmic-import: qtWvXH8Uhh67sc1TY2MZeK/projectcss
import projectcss from "./plasmic_hub_hub.module.css"; // plasmic-import: 24qDGfvb2rMn6oy8PVF95d/projectcss
import sty from "./PlasmicCircleButton.module.css"; // plasmic-import: CMg-M2mVji/css

import BlueCircleIcon from "./icons/PlasmicIcon__BlueCircle"; // plasmic-import: VIYOCOF-zp/icon
import Add24FilledIcon from "./icons/PlasmicIcon__Add24Filled"; // plasmic-import: W5RSWrKI-W/icon
import VectorIcon from "./icons/PlasmicIcon__Vector"; // plasmic-import: -gNKA8h-Z4/icon

createPlasmicElementProxy;

export type PlasmicCircleButton__VariantMembers = {
  selected: "selected";
  small: "small";
  large: "large";
  medium: "medium";
  color: "mountainBlue" | "logoBlue" | "eggshell" | "red";
  scale: "small" | "medium" | "large";
};
export type PlasmicCircleButton__VariantsArgs = {
  selected?: SingleBooleanChoiceArg<"selected">;
  small?: SingleBooleanChoiceArg<"small">;
  large?: SingleBooleanChoiceArg<"large">;
  medium?: SingleBooleanChoiceArg<"medium">;
  color?: SingleChoiceArg<"mountainBlue" | "logoBlue" | "eggshell" | "red">;
  scale?: SingleChoiceArg<"small" | "medium" | "large">;
};
type VariantPropType = keyof PlasmicCircleButton__VariantsArgs;
export const PlasmicCircleButton__VariantProps = new Array<VariantPropType>(
  "selected",
  "small",
  "large",
  "medium",
  "color",
  "scale"
);

export type PlasmicCircleButton__ArgsType = {};
type ArgPropType = keyof PlasmicCircleButton__ArgsType;
export const PlasmicCircleButton__ArgProps = new Array<ArgPropType>();

export type PlasmicCircleButton__OverridesType = {
  root?: p.Flex<"button">;
  buttonContent?: p.Flex<"div">;
};

export interface DefaultCircleButtonProps {
  selected?: SingleBooleanChoiceArg<"selected">;
  small?: SingleBooleanChoiceArg<"small">;
  large?: SingleBooleanChoiceArg<"large">;
  medium?: SingleBooleanChoiceArg<"medium">;
  color?: SingleChoiceArg<"mountainBlue" | "logoBlue" | "eggshell" | "red">;
  scale?: SingleChoiceArg<"small" | "medium" | "large">;
  className?: string;
}

const $$ = {};

function PlasmicCircleButton__RenderFunc(props: {
  variants: PlasmicCircleButton__VariantsArgs;
  args: PlasmicCircleButton__ArgsType;
  overrides: PlasmicCircleButton__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(() => Object.assign({}, props.args), [props.args]);

  const $props = {
    ...args,
    ...variants
  };

  const $ctx = ph.useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const currentUser = p.useCurrentUser?.() || {};

  const stateSpecs: Parameters<typeof p.useDollarState>[0] = React.useMemo(
    () => [
      {
        path: "selected",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.selected
      },
      {
        path: "small",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.small
      },
      {
        path: "large",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.large
      },
      {
        path: "medium",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.medium
      },
      {
        path: "color",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.color
      },
      {
        path: "scale",
        type: "private",
        variableType: "variant",
        initFunc: ({ $props, $state, $queries, $ctx }) => $props.scale
      }
    ],
    [$props, $ctx, $refs]
  );
  const $state = p.useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });

  return (
    <button
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.button,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        plasmic_plasmic_rich_components_css.plasmic_tokens,
        plasmic_pro_pro_css.plasmic_tokens,
        sty.root,
        {
          [sty.rootcolor_red]: hasVariant($state, "color", "red"),
          [sty.rootlarge]: hasVariant($state, "large", "large"),
          [sty.rootmedium]: hasVariant($state, "medium", "medium"),
          [sty.rootscale_large]: hasVariant($state, "scale", "large"),
          [sty.rootscale_medium]: hasVariant($state, "scale", "medium"),
          [sty.rootscale_small]: hasVariant($state, "scale", "small"),
          [sty.rootselected]: hasVariant($state, "selected", "selected"),
          [sty.rootsmall]: hasVariant($state, "small", "small")
        }
      )}
    >
      <div
        data-plasmic-name={"buttonContent"}
        data-plasmic-override={overrides.buttonContent}
        className={classNames(projectcss.all, sty.buttonContent, {
          [sty.buttonContentlarge]: hasVariant($state, "large", "large"),
          [sty.buttonContentmedium]: hasVariant($state, "medium", "medium"),
          [sty.buttonContentscale_large]: hasVariant($state, "scale", "large"),
          [sty.buttonContentscale_medium]: hasVariant(
            $state,
            "scale",
            "medium"
          ),
          [sty.buttonContentscale_small]: hasVariant($state, "scale", "small"),
          [sty.buttonContentsmall]: hasVariant($state, "small", "small")
        })}
      >
        <BlueCircleIcon
          className={classNames(projectcss.all, sty.svg__civLs, {
            [sty.svgcolor_eggshell__civLsdzMy7]: hasVariant(
              $state,
              "color",
              "eggshell"
            ),
            [sty.svgcolor_logoBlue__civLssuPhd]: hasVariant(
              $state,
              "color",
              "logoBlue"
            ),
            [sty.svgcolor_red__civLsKLzAh]: hasVariant($state, "color", "red"),
            [sty.svglarge__civLsr328]: hasVariant($state, "large", "large"),
            [sty.svgmedium__civLsJHq4B]: hasVariant($state, "medium", "medium"),
            [sty.svgscale_large__civLsMc4At]: hasVariant(
              $state,
              "scale",
              "large"
            ),
            [sty.svgscale_medium__civLsAGnhE]: hasVariant(
              $state,
              "scale",
              "medium"
            ),
            [sty.svgscale_small__civLsIbh7Q]: hasVariant(
              $state,
              "scale",
              "small"
            ),
            [sty.svgselected__civLsBIuB]: hasVariant(
              $state,
              "selected",
              "selected"
            ),
            [sty.svgsmall__civLs0Znm]: hasVariant($state, "small", "small")
          })}
          role={"img"}
        />

        {(hasVariant($state, "selected", "selected") ? false : true) ? (
          <Add24FilledIcon
            className={classNames(projectcss.all, sty.svg__pJ9G, {
              [sty.svgcolor_eggshell__pJ9GdzMy7]: hasVariant(
                $state,
                "color",
                "eggshell"
              ),
              [sty.svgcolor_red__pJ9GKLzAh]: hasVariant($state, "color", "red"),
              [sty.svglarge__pJ9Gr328]: hasVariant($state, "large", "large"),
              [sty.svgmedium__pJ9GJHq4B]: hasVariant(
                $state,
                "medium",
                "medium"
              ),
              [sty.svgscale_medium__pJ9GAGnhE]: hasVariant(
                $state,
                "scale",
                "medium"
              ),
              [sty.svgscale_small__pJ9GIbh7Q]: hasVariant(
                $state,
                "scale",
                "small"
              ),
              [sty.svgselected__pJ9GBIuB]: hasVariant(
                $state,
                "selected",
                "selected"
              ),
              [sty.svgsmall__pJ9G0Znm]: hasVariant($state, "small", "small")
            })}
            role={"img"}
          />
        ) : null}
        {(hasVariant($state, "selected", "selected") ? true : false) ? (
          <VectorIcon
            className={classNames(projectcss.all, sty.svg__duhK8, {
              [sty.svgselected__duhK8BIuB]: hasVariant(
                $state,
                "selected",
                "selected"
              )
            })}
            role={"img"}
          />
        ) : null}
      </div>
    </button>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "buttonContent"],
  buttonContent: ["buttonContent"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "button";
  buttonContent: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicCircleButton__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicCircleButton__VariantsArgs;
    args?: PlasmicCircleButton__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicCircleButton__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    /* Specify args directly as props*/ Omit<
      PlasmicCircleButton__ArgsType,
      ReservedPropsType
    > &
    /* Specify overrides for each element directly as props*/ Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    /* Specify props for the root element*/ Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicCircleButton__ArgProps,
          internalVariantPropNames: PlasmicCircleButton__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicCircleButton__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicCircleButton";
  } else {
    func.displayName = `PlasmicCircleButton.${nodeName}`;
  }
  return func;
}

export const PlasmicCircleButton = Object.assign(
  // Top-level PlasmicCircleButton renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    buttonContent: makeNodeComponent("buttonContent"),

    // Metadata about props expected for PlasmicCircleButton
    internalVariantProps: PlasmicCircleButton__VariantProps,
    internalArgProps: PlasmicCircleButton__ArgProps
  }
);

export default PlasmicCircleButton;
/* prettier-ignore-end */
